/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React, { useMemo } from 'react';
import { unstable } from '@broadleaf/admin-components';

const {
  Image,
  Link,
  SanitizeHTML,
  useCurrentApplication,
  useCurrentTenant
} = unstable;

const AuroraNavLogo = () => {
  const tenant = useCurrentTenant();
  const application = useCurrentApplication();
  const logoAsset = useLogoAsset(tenant, application);
  return (
    <Link
      className="tw-flex tw-max-h-full tw-max-w-full tw-items-center tw-justify-center"
      to="/"
    >
      {logoAsset ? <LogoAsset asset={logoAsset} /> : <DefaultLogo />}
    </Link>
  );
};

const LogoAsset = ({ asset }) => {
  if (asset.type === 'EMBED') {
    return (
      <SanitizeHTML
        className="tw-max-h-full tw-max-w-full"
        html={asset.embedCode}
      />
    );
  }
  return (
    <Image
      className="tw-max-h-full tw-max-w-full"
      src={asset.contentUrl}
      alt={asset.altText || 'Logo'}
    />
  );
};

const DefaultLogo = () => (
  <svg
    className="tw-h-24 tw-w-24 tw-fill-current tw-text-green-700"
    viewBox="0 -5 35 35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.552 19.78L16 25h.828C18.863 17.362 18.63 13.064 3.31 5.22c4.068 2.031 6.6 3.269 11.862 5.769 3.303 2.377 4.047 4.296 3.31 8.791 2.308-2.285 4.487-2.823 9.932-2.472-8.266.493-9.812 2.677-10.759 7.692h1.104l.551-2.198.03.004c4.959.579 7.748.905 15.143-7.97-9.1-.727-13.784-.954-15.173 1.647 1.049-3.281-.374-8.548-3.31-9.89C13.064 5.252 3.318 2.41 0 0c.356 4.945 1.432 8.059 5.793 14.56 4.572 4.792 6.841 5.295 10.759 5.22z" />
  </svg>
);

function useLogoAsset(tenant, application) {
  return useMemo(() => {
    if (application && application.adminLogoAsset) {
      return application.adminLogoAsset;
    }

    if (application && application.logoAsset) {
      return application.logoAsset;
    }

    return tenant ? tenant.adminLogoAsset : null;
  }, [application, tenant]);
}

export default AuroraNavLogo;
export { AuroraNavLogo };
